// extracted by mini-css-extract-plugin
export default {"orange_btn":"Button_orange_btn__5rcZC","active":"Button_active__QCN4f","price":"Button_price__qokIe","green_btn":"Button_green_btn__d9-6L"};